module.exports = __webpack_public_path__ + "static/img/bgscreenimg21.507975b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscreenimg21.png
// module id = 63BF
// module chunks = 4